export default {
    // light:本番, dark:未使用
    light: {
        HeaderHeight: 70,
        SearchHeaderHeight: 76,
        HeaderImgWidth: 100,
        HeaderImgHeight: 42,
        HeaderImgMarginBottom: 26,
        PosTop: '15px',
        DrawerTop: '70px',
        Display: 'flex',
        MenuTxt: 'オススメ',
        RecommendDisplay: 'flex',
        HeaderTxt: '',
        LoginTitle: '',
        LoginNoticeTitle: '【ログイン機能停止のお知らせ】',
        LoginNotice:
            '2026年3月2日（月）10:00～12:00の間、\nログインパスワード変更作業を実施いたします。\n上記時間帯はログインできません。\n作業完了後は、新しいログインパスワードで\nログインしてください。\n※ログインパスワードはDO YOU！\n　ホームページと同じです。',
        LoginPeriod:
            'ログインパスワードはイオン同友店会 DO YOU！\nホームページのログインパスワードと同じです。\nご不明な場合はSC事務所へご確認ください。',
        LoginPeriodFontSize: 14,
        TenantNamePlaceholder: '専門店名のみ入力してください',
        SearchOptionsVisible: true,
        LoginText: 'ログインパスワード',
        Placeholder: 'パスワードを入力してください',
        PlaceholderFontSize: 12,
        loginTitleBoxSize: '40%',
        loginTextBoxSize: '60%'
    },
    dark: {
        HeaderHeight: 70,
        SearchHeaderHeight: 76,
        HeaderImgWidth: 135,
        HeaderImgHeight: 47,
        HeaderImgMarginBottom: 26,
        PosTop: '15px',
        DrawerTop: '70px',
        Display: 'flex',
        MenuTxt: 'オススメ',
        RecommendDisplay: 'flex',
        HeaderTxt: '',
        LoginTitle: '',
        LoginNoticeTitle: '【ログイン機能停止のお知らせ】',
        LoginNotice:
            '2026年3月2日（月）10:00～12:00の間、\nログインパスワード変更作業を実施いたします。\n上記時間帯はログインできません。\n作業完了後は、新しいログインパスワードで\nログインしてください。\n※ログインパスワードはDO YOU！\n　ホームページと同じです。',
        LoginPeriod:
            'ログインパスワードはイオン同友店会 DO YOU！\nホームページのログインパスワードと同じです。\nご不明な場合はSC事務所へご確認ください。',
        LoginPeriodFontSize: 14,
        TenantNamePlaceholder: '専門店名のみ入力してください',
        SearchOptionsVisible: true,
        LoginText: 'ログインパスワード',
        Placeholder: 'パスワードを入力してください',
        PlaceholderFontSize: 12,
        loginTitleBoxSize: '40%',
        loginTextBoxSize: '60%'
    },
    disney: {
        HeaderHeight: 90,
        SearchHeaderHeight: 96,
        HeaderImgWidth: 140,
        HeaderImgHeight: 70,
        HeaderImgMarginBottom: 52,
        PosTop: '10px',
        DrawerTop: '90px',
        Display: 'none',
        MenuTxt: 'ツール',
        RecommendDisplay: 'flex',
        HeaderTxt:
            '11月1日（金）から12月25日（水）までの間で、『AEONMALL Wonderful Christmas　ディスプレイコンテスト』を開催！ディズニー関連商品をお取り扱いの店舗さまを対象とした特別なディスプレイコンテスト！期間中に売り場でのディスプレイ演出を行っていただき、入賞された各店舗様には、特別な賞品を用意しておりますので、対象のディスプレイ・店舗画像をご投稿ください。',
        LoginTitle: '『AEONMALL Wonderful Christmas　ディスプレイコンテスト』公式ページ',
        LoginNoticeTitle: '',
        LoginNotice: '',
        LoginPeriod: '応募期間：11月1日（金）～12月25日（水）',
        LoginPeriodFontSize: 18,
        TenantNamePlaceholder: '専門店名のみ入力してください',
        SearchOptionsVisible: false,
        LoginText: 'ログインID',
        Placeholder: 'ログインIDを入力してください',
        PlaceholderFontSize: 14,
        loginTitleBoxSize: '25%',
        loginTextBoxSize: '75%'
    }
};
